<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="收支记录号" name="record_number"></c-form-item>
					<c-form-item type="input" label="业务单号" name="docket_number"></c-form-item>
					<c-form-item type="input" label="摘要" name="remark"></c-form-item>
					<c-form-item type="select" label="账单类型" name="trans_type" :options="transType"></c-form-item>
					<c-form-item type="select" label="收付渠道" name="trans_channel" :options="transChannel"></c-form-item>
					<c-form-item type="select" label="收支类型" name="income_expenses" :options="incomeExpenses"></c-form-item>
					<c-form-item type="datetime" label="交易时间" start-name="begin_time" end-name="end_time"></c-form-item>
                    <c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
                    <c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
					<c-form-item type="checkbox" label="交易状态" name="trans_state" :options="transState" ></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button color="sys" power="b_member_account_record_export"  @click="exportJob()">异步导出</c-button>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="收支记录号"
					name="record_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="交易状态"
					name="trans_state"
					width="80"
				>
                  <template v-slot="{data}">
                    <span style="color:green" v-if="data.trans_state==1">{{transStateName[data.trans_state]}}</span>
                    <span style="color:dodgerblue" v-if="data.trans_state==2">{{transStateName[data.trans_state]}}</span>
                    <span style="color:gray" v-if="data.trans_state==3">{{transStateName[data.trans_state]}}</span>
                  </template>
				</c-table-column>
				
				<c-table-column
					label="交易摘要"
					name="remark"
					width="270"
				></c-table-column>

                <c-table-column
                    label="代理手机号"
                    name="user_manage_mobilephone"
                    width="120"
                ></c-table-column>

                <c-table-column
                    label="代理头像/昵称"
                    name="head_photo"
                    width="140"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>
				

				<c-table-column
					label="交易时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="收支类型"
					name="income_expenses"
					width="80"
				>
					<template v-slot="{data}">
                        <span style="color:green" v-if="data.income_expenses==1">{{incomeExpensesName[data.income_expenses]}}</span>
                        <span style="color:red" v-if="data.income_expenses==2">{{incomeExpensesName[data.income_expenses]}}</span>
                        <span style="color:gray" v-if="data.income_expenses==3">{{incomeExpensesName[data.income_expenses]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="交易金额"
					name="money"
					width="100"
				>
                  <template v-slot="{data}">
                    <span>￥{{(data.money||0).toFixed(2)}}</span>
                  </template>
                </c-table-column>
				
				<c-table-column
					label="商品数量"
					name="count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="余额"
					width="100"
					name="surplus_money"
					v-if="systemConfig.account_balance_enabled == 'ON'"
				>
                  <template v-slot="{data}">
                    <span>￥{{(data.surplus_money||0).toFixed(2)}}</span>
                  </template>
                </c-table-column>
				
				<c-table-column
					label="业务单号"
					name="docket_number"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="第三方支付单号"
					name="third_number"
					width="235"
				></c-table-column>
				
				<c-table-column
					label="分类"
					width="80"
					name="trans_classify"
				></c-table-column>
				
				<c-table-column
					label="账单类型"
					name="trans_type"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="收付渠道"
					name="trans_channel"
					width="80"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/member_account_record_detail/${data.id}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		name: 'm_member_account_record',

		data() {
			return {
                workType:7,
                searchParams:{},
				transStateName: {
					1: '交易成功',
					2: '处理中',
					3: '提现失败'
				},
				incomeExpensesName:{
					1: '收入',
					2: '支出'
				},
                transChannel:[
                    {name: '微信',value:'微信'},
                    {name: '转账支付',value: '转账支付'},
                    {name: '余额',value: '余额'}
				],
				incomeExpenses: [
                    {name: '收入',value: "1"},
                    {name: '支出',value: "2"}
				],
				transState: [{
						name: '交易成功',
						value: 1
					},{
						name: '处理中',
						value: 2
					},{
						name: '提现失败',
						value: 3
					}
				],
				transType: [
					// {
					// 	name: '余额充值',
					// 	value: "余额充值"
					// },
					{
						name: '订单消费',
						value: "订单消费"
					},{
						name: '订单退款',
						value: "订单退款"
					},{
						name: '余额补款',
						value: "余额补款"
					},{
						name: '余额扣款',
						value: "余额扣款"
					},{
						name: '差价返佣',
						value: "下单差价返佣"
					},{
						name: '佣金补款',
						value: '佣金补款'
					},{
						name: '佣金扣款',
						value: '佣金扣款'
					},{
						name: '区代奖励',
						value: '区代奖励'
					}
				]
			}
		},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
        },
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
		        this.$refs.table.load({
                    url: '/user/account/record/list',
                    data
                });
                this.searchParams = data||{};
            },
            exportJob() {
                this.searchParams.job_id = 16;
				this.request({
					url: '/export_job/add',
					data: this.searchParams,
					loading: true,
					success: data => {
						this.$message({
							text: '导出任务提交成功，请稍后前往任务中心查看',
							icon: 'success'
						});
					}
				});
			},
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>